// import 'core-js/es6/array'; // Required by IE11 for detect-browser
// import 'core-js/es6/promise'; // Required by IE11 for detect-browser
//const { detect } = require('detect-browser');

const loginAndRun = async () => {
   
    // Dynamically import polyfills only as needed
    // const browserName = detect().name;
    // if(browserName === 'ie') {
    //     await import('./polyfill.ie11');
    // } else if(browserName === 'edge') {
    //     await import('./polyfill.edge');
    // }

    // Import MSAL utilities
    const { logIn, isLoggedIn, handleRedirectResult } = await import('./services/auth/msalUtils');

    // Prevent execution inside iframes (used by MSAL for silent token renewal in v1, 
    // but v3 uses refresh tokens instead - keeping this for safety)
    if(window !== window.parent) return;

    // MSAL v3: Must call handleRedirectPromise on page load to process any redirect response
    await handleRedirectResult();

    if(!isLoggedIn()) {
        await logIn();
    }

    const [
        React,
        ReactDom,
        { App }
    ] = await Promise.all([
        import('react'),
        import('react-dom'),
        import('./App')
    ]);

    ReactDom.render(
        <App/>,
        document.getElementById("root"));
}

loginAndRun();